import React from 'react'

import styled from 'styled-components'

import Arrow from 'src/Assets/Svg/common/down-arrow.svg?react'
import {
  SquareButton,
  SquareButtonProps,
} from 'src/Components/Buttons/SquareButton'

const StyledButton = styled(SquareButton)`
  width: 16px;
  height: 16px;
  padding: 0;
  border-radius: 4px;
  border: none;
  background: transparent;

  svg {
    path {
      fill: ${({ theme }) => theme.color.darkGrey};
    }
  }

  &:hover {
    background: ${({ theme }) => theme.color.lightGrey};
  }

  &:focus-visible {
    background: ${({ theme }) => theme.color.white};
    outline: 1px solid ${({ theme }) => theme.color.brandGreen};
    outline-offset: -1px;

    svg {
      path {
        fill: ${({ theme }) => theme.color.darkGrey};
      }
    }
  }

  &:active {
    background: ${({ theme }) => theme.color.lightGrey};
    outline: none;

    svg {
      path {
        fill: ${({ theme }) => theme.color.mediumGrey};
      }
    }
  }

  &:disabled {
    background: transparent;

    svg {
      path {
        fill: ${({ theme }) => theme.color.lightGrey};
      }
    }
  }
`

export const RotateIconWrapper = styled.div<{ $isDown: boolean }>`
  transform: rotate(${({ $isDown }) => ($isDown ? '0deg' : '180deg')});
  scale: -1;
  transition: transform 0.3s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export type ArrowButtonProps = Pick<
  SquareButtonProps,
  'onClick' | 'disabled' | 'className'
> & {
  isDown?: boolean
}

export const ArrowButton: React.FC<ArrowButtonProps> = ({
  onClick,
  disabled,
  isDown,
  className,
}) => (
  <StyledButton
    type='button'
    disabled={disabled}
    onClick={onClick}
    className={className}
  >
    <RotateIconWrapper $isDown={Boolean(isDown)}>
      <Arrow />
    </RotateIconWrapper>
  </StyledButton>
)
